var t, i;
function s() {
  if (i) return t;
  i = 1;
  return t = class {
    constructor(t) {
      this.street = t.street, this.locality = t.locality, this.administrativeArea = t.administrative_area, this.administrativeAreaShort = t.administrative_area_short, this.administrativeAreaLong = t.administrative_area_long, this.postalCode = t.postal_code, this.countryIso3 = t.country_iso3, this.entries = t.entries, this.addressText = t.address_text, this.addressId = t.address_id;
    }
  };
}
export { s as __require };